
import { DateTime } from 'luxon';
import React from 'react';

const Footer = () => (
<footer className="footer d-flex justify-content-center">
    <p className="text-center">
        <span className="d-none d-md-inline">21 S. Henry St, Delaware, OH 43015 | </span>
        Knights of Columbus - Council 1056 | Copyright &copy; {DateTime.now().year}
    </p>
</footer>
);

export default Footer;